import axios from 'axios'
import { SEARCH_REDIRECTS } from 'services/utility/constants'
import errorHandler from './errorHandler'

export default () => axios
  .get(SEARCH_REDIRECTS)
  .then(response => response.data)
  .catch(errorHandler)



// WEBPACK FOOTER //
// ./services/api/search-redirects.js